import React, { useEffect, useState } from "react";
import SearchOrAddDropdown from "../../../../AutoNurture/SideCardsForAutoNurture/childCompsForNurtureCard/NurtureCampaignContact/SearchOrAddDropdown";
import SimpleDateField from "../../../../genericComponents/simpleTextField/SimpleDateField";
import SimpleTextField from "../../../../genericComponents/simpleTextField/SimpleTextField";

function ReachoutInit({
  allOpps,
  selectedOpportunity,
  setSelectedOpportunity,
  allProducts,
  selectedProducts = {},
  setSelectedProducts,
  startDate,
  setStartDate,
  emailsPerContact,setEmailsPerContact
}) {
  

  return (
    <div style={{ maxWidth: "50%" }}>
      <label className="nccs-field">
        <span className="nccs-label stf-label">What is your Opportunity ?</span>
        <SearchOrAddDropdown
          placeholder="Select an Opportunity"
          options={allOpps}
          value={selectedOpportunity}
          onChange={setSelectedOpportunity}
          mode="single"
          showCount={false}
          returnType="object"
          labelKey="opportunity_name"
          valueKey="_id"
          searchMode="search-only"
        />
      </label>
      <label className="nccs-field" style={{marginTop:"1.5rem",marginBottom:"1.5rem"}}>
        <span className="nccs-label stf-label">What Are You Selling ?</span>
        <span
          className="what_selling_wrapper"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: "1rem",
            position: "relative",
          }}
        >
          <SearchOrAddDropdown
            placeholder="Choose One or More Products"
            options={allProducts}
            value={selectedProducts}
            onChange={setSelectedProducts}
            mode="multiple"
            showCount={false}
            noEditPlaceHolder={true}
            valueKey="name"
            labelKey="name"
            returnType="object"
            searchMode="search"
          />

          <div className="selected_count">
            {selectedProducts?.length > 0 && (
              <>{selectedProducts?.length} Selected</>
            )}
          </div>
        </span>
      </label>


      <label className="nccs-field" style={{marginTop:"2rem !important"}}>
              <span className="nccs-label stf-label">
                Number of emails to generate per contact
              </span>
              <SearchOrAddDropdown
                placeholder="e.g, 3"
                options={[
                  { label: 1, value: 1 },
                  { label: 2, value: 2 },
                  { label: 3, value: 3 },
                  // { label: 4, value: 4 },
                  // { label: 5, value: 5 },
                ]}
                value={emailsPerContact}
                onChange={setEmailsPerContact}
                mode="single"
                showCount={false}
                returnType="value"
                labelKey="label"
                valueKey="value"
                searchMode="search-only"
              />
            </label>
      <span
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          marginTop: "1.5rem",
        }}
      >
        <SimpleDateField
          disablePastDates={true}
          label="Campaign Start Date"
          labelPosition="top-left"
          value={startDate}
          onChange={(val) => {
            setStartDate(val);
          }}
          minDate={new Date(2020, 0, 1)}
          maxDate={new Date(2030, 11, 31)}
          disableWeekends
          customWidth="100%"
        />
      </span>

      {/* <span  style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          marginTop: "1rem",
        }}>
        {" "}
        <SimpleTextAreaField
          label="Custom Instructions (Optional)"
          placeholder="Describe the purpose and tone for this campaign…"
          rows={3}
          value={customInstruction}
          onChange={(e) => setCustomInstruction(e.target.value)}
          customWidth="100%"
        />
      </span> */}
    </div>
  );
}

export default ReachoutInit;
